var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['cbo-videoplayer', {'videoplayer--cover':_vm.cover}]},[(_vm.isOnline && _vm.src)?_c('video',{attrs:{"controls":"","playsinline":""}},[_c('source',{attrs:{"src":_vm.src}})]):_c('div',{staticClass:"videoplayer-offline"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.$strings.video_offline_text)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }